import React from "react";
import axios from "axios";

const CheckPayment = () => {
    // const testSubmit = async (id) => {
    //     try {
    //       const response = await axios.post("", {
    //         customerID: "cus_Nal8W0CqJ4uDLg",
    //         amount: 200,
    //         resID: id,
    //       });
    //       console.log(response);
    //       window.location.href = `${response.data}`;
    //     } catch (error) {
    //       console.log(error.message);
    //     }
    //   };

    const testSubmit = async (id) => {
        try {
            const resp = await axios.post(
                "https://softcar-chrentacar-test-43b9adc2e8ec.herokuapp.com/checkout-session",
                {
                    customerID: "cus_Nal8W0CqJ4uDLg",
                    amount: 200,
                    resID: id,
                },
            );
            // console.log(resp.data);
            window.location.href = `${resp.data}`;
        } catch (_err) {
            // Handle Error Here
            // console.error(err);
        }
    };
    return (
        <div>
            <button
                onClick={() => {
                    testSubmit("gjvXWrzLTs7YhiZanfHT");
                }}>
                Pay Now
            </button>
        </div>
    );
};

export default CheckPayment;
